import { render, staticRenderFns } from "./PatternEditor.vue?vue&type=template&id=1b86e432&scoped=true&"
import script from "./PatternEditor.vue?vue&type=script&lang=js&"
export * from "./PatternEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b86e432",
  null
  
)

export default component.exports